import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { I18nContext, Language, translate } from './index';

type Props = { children: React.ReactNode };

const STORAGE_KEY = 'osler-language';

function detectBrowserLang(): Language {
  try {
    const nav = typeof navigator !== 'undefined' && navigator.language ? navigator.language : 'ko';
    return nav.toLowerCase().startsWith('en') ? 'en' : 'ko';
  } catch {
    return 'ko';
  }
}

export const I18nProvider: React.FC<Props> = ({ children }) => {
  const [language, setLanguage] = useState<Language>('ko');

  // 초기 언어 복원
  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      const savedLang = saved === 'en' || saved === 'ko' ? (saved as Language) : null;
      const initial: Language = savedLang ?? detectBrowserLang();
      setLanguage(initial);
      if (typeof document !== 'undefined') document.documentElement.lang = initial;
    } catch {
      // noop
    }
  }, []);

  // 변경 시 저장/동기화
  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, language);
      if (typeof document !== 'undefined') document.documentElement.lang = language;
    } catch {
      // noop
    }
  }, [language]);

  const t = useCallback((key: string, params?: Record<string, unknown>) => {
    return translate(language, key, params);
  }, [language]);

  const value = useMemo(() => ({ language, setLanguage, t }), [language, t]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};
